import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import utc from 'dayjs/plugin/utc';
import {IV_PROCESS_TYPE} from '@chekin/core';

dayjs.extend(isBetween);
dayjs.extend(utc);

type Params = {
  isIVEnabled?: boolean;
  processType?: string | null;
  checkInDate?: string | null;
  checkOutDate?: string | null;
  today?: dayjs.ConfigType;
};

type IVOnPropertyState = {
  isIVOnProperty: boolean;
  isIVOnPropertyEnabled: boolean;
  isIVOnPropertyAvailable: boolean;
  isIVOnPropertyUnavailable: boolean;
};

function isWithinStay({
  checkInDate,
  checkOutDate,
  today,
}: Pick<Params, 'checkInDate' | 'checkOutDate' | 'today'>) {
  if (!checkInDate || !checkOutDate) return false;
  const day = dayjs(today).utc().startOf('day');
  const checkIn = dayjs(checkInDate).utc().startOf('day');
  const checkOut = dayjs(checkOutDate).utc().startOf('day');

  return day.isBetween(checkIn, checkOut, 'day', '[]');
}

function getIVOnPropertyState({
  isIVEnabled,
  processType,
  checkInDate,
  checkOutDate,
  today,
}: Params): IVOnPropertyState {
  const isIVOnProperty = processType === IV_PROCESS_TYPE.onProperty;
  const isIVOnPropertyEnabled = Boolean(isIVEnabled) && isIVOnProperty;
  const isInStay = isWithinStay({checkInDate, checkOutDate, today});

  return {
    isIVOnProperty,
    isIVOnPropertyEnabled,
    isIVOnPropertyAvailable: isIVOnPropertyEnabled && isInStay,
    isIVOnPropertyUnavailable: isIVOnPropertyEnabled && !isInStay,
  };
}

export {getIVOnPropertyState};
export type {IVOnPropertyState};
